import { useQuery } from "@tanstack/react-query";
import axiosConfig from "../axiosInstance";

export const useGetFaqs = () =>
  useQuery({
    queryKey: ["useGetFaqs"],
    queryFn: async () => await axiosConfig.get("/FAQ"),
  });
